import styled from 'styled-components';

export const StyledOrderReview = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  padding-top: 30px;

  .order-received-title {
    font-size: 18px;
    font-weight: 600;
    padding: 0 20px 4px 20px;
    display: none;
  }

  .back-button {
    align-items: center;
    gap: 4px;
    padding: 37px 0px 17px 20px;
    border-bottom: 1px solid ${(props) => props.theme.lightGrayBorder};
    font-size: 14px;
    font-weight: 400;
    div {
      display: flex;
      height: 17px;
      width: 17px;
    }
    display: none;
  }

  .grouped-farm-cart-wrap {
    width: 61%;
  }

  @media only screen and (max-width: 1200px) {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .order-received-title {
      display: block;
    }

    .back-button {
      display: flex;
    }

    .grouped-farm-cart-wrap {
      padding: 0 20px 20px;
      width: 100%;
    }
  }

  @media only screen and (max-width: 576px) {
    padding-top: 0;
    .form-title {
      display: block;
    }
  }
`;

export const StyledOrderReviewWrapper = styled.div`
  .form-title {
    display: none;
    margin-top: 14px;
  }

  @media only screen and (max-width: 576px) {
    .form-title {
      display: block;
    }
  }

  .order-review-warning-container {
    padding: 18px !important;
  }
`;
